/* src/app/forms/market-place-tabs/generic-tab/generic-tab.component.scss */
:host {
  height: 100%;
  width: 100%;
}
.maindiv {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=generic-tab.component.css.map */
